class HeroSeparatorCoverOverlap {
  constructor() {
    this.desktopMediaQuery = window.matchMedia("(min-width: 1025px)");
    this.innerSelector = ".lc-hero-separator-cover__inner";
    this.visibleOnImagePx = 64;

    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.updateOffsets = this.updateOffsets.bind(this);

    this.observeInners();
    this.updateOffsets();

    this.desktopMediaQuery.addEventListener("change", this.handleViewportChange);
    window.addEventListener("resize", this.updateOffsets);
    window.addEventListener("orientationchange", this.updateOffsets);
  }

  observeInners() {
    this.inners = Array.from(document.querySelectorAll(this.innerSelector));

    if (!window.ResizeObserver) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => {
      this.updateOffsets();
    });

    this.inners.forEach(inner => {
      this.resizeObserver.observe(inner);
    });
  }

  handleViewportChange() {
    this.updateOffsets();
  }

  updateOffsets() {
    this.inners = Array.from(document.querySelectorAll(this.innerSelector));

    this.inners.forEach(inner => {
      const component = inner.closest(".lc-hero-separator-cover");

      if (!this.desktopMediaQuery.matches) {
        inner.style.removeProperty("--hero-separator-overlap-offset");
        if (component) {
          component.style.removeProperty("--hero-separator-overlap-offset");
        }
        return;
      }

      const innerHeight = inner.getBoundingClientRect().height;
      const offset = Math.max(innerHeight - this.visibleOnImagePx, 0);

      inner.style.setProperty("--hero-separator-overlap-offset", `${offset}px`);
      if (component) {
        component.style.setProperty("--hero-separator-overlap-offset", `${offset}px`);
      }
    });
  }

  unsubscribe() {
    this.desktopMediaQuery.removeEventListener("change", this.handleViewportChange);
    window.removeEventListener("resize", this.updateOffsets);
    window.removeEventListener("orientationchange", this.updateOffsets);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.inners) {
      this.inners.forEach(inner => {
        const component = inner.closest(".lc-hero-separator-cover");
        inner.style.removeProperty("--hero-separator-overlap-offset");
        if (component) {
          component.style.removeProperty("--hero-separator-overlap-offset");
        }
      });
    }
  }
}

export default HeroSeparatorCoverOverlap;
